import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { RecuperarInfoService } from '../../services/recuperarInfo/recuperar-info.service';
//import { CaptchaService } from "../../services/captcha/captcha.service";
import { RecaptchaV3Service } from "../../services/recaptcha-v3/recaptcha-v3.service";
import { LoginService } from "../../services/login/login.service";
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ConfigurationService } from '../../services/configuration/configuration.service';
import { MensajeRespuestaDTO } from '../../model/mensajeRespuestaDTO';
import { NgxSpinnerService } from 'ngx-spinner';
import { WhiteListDTO } from '../../model/witheList.dto';

// import { InvisibleReCaptchaComponent } from 'ngx-captcha';

//Variable del global scope para utilizar jquery
declare var $: any;

@Component({
  selector: 'app-recuperar-info',
  templateUrl: './recuperar-info.component.html',
  styleUrls: ['./recuperar-info.component.css'],
  providers: [RecuperarInfoService, /*CaptchaService*/]
})

export class RecuperarInfoComponent implements OnInit {

  //lenguaje del navegador
  public defaultLanguage: string;

  //Lista que contiene los tipos de documento.
  public listaTipoDocumentos: any;

  //Atributo que indica el mensaje generado por el rest.
  public mensajeSalida: MensajeRespuestaDTO;

  //Atributo que indica el tipo de componente a mostrar.
  public tipoComponente: string;

  //Atributo que contiene el tipo de opcion seleccionada
  public selOpt: string;

  /**
   * Atributo que contiene la información de variables del grupo.
   */
  public profileForm: UntypedFormGroup;

  /**
   *
   */
  // @ViewChild('captchaElem') captchaElem: InvisibleReCaptchaComponent;

  /**
   * Constructor component.
   * @param _translateService
   * @param _recuperarInfoServices
   * @param _activatedRoute
   * @param _formB
   */
  constructor(private _translateService: TranslateService,
    private _recuperarInfoServices: RecuperarInfoService,
    private _activatedRoute: ActivatedRoute,
    private _formB: UntypedFormBuilder,
    private _spinner: NgxSpinnerService,
    private _configurationService: ConfigurationService,
    private _recaptchaService: RecaptchaV3Service,
    private _loginService: LoginService,
    private _configurationControlService: ConfigurationControlService) {

    this._spinner.show();
    this.getNavigatorLang();
    this._translateService.addLangs(["es", "en"]);
    this._translateService.use(this.defaultLanguage);
    //this.listaTipoDocumentos = [
    //   { tipo: 'CC', valor: 'Cédula de ciudadanía' },
    //   { tipo: 'CE', valor: 'Cédula de extranjería' },
    //   { tipo: 'CR', valor: 'Contraseña registraduría'},
    //   { tipo: 'NES', valor: 'Número identificación Secretaría de Educación'},
    //   { tipo: 'PC', valor: 'Pasaporte colombiano'},
    //   { tipo: 'PE', valor: 'Pasaporte extranjero'},
    //   { tipo: 'PEP', valor: 'Permiso especial de permanencia'},
    //   { tipo: 'PPT', valor: 'Permiso por protección temporal'},
    //   { tipo: 'TI', valor: 'Tarjeta de identidad' }];
    this.tipoComponente = this._activatedRoute.snapshot.params['tInfo'];
    this.mensajeSalida = new MensajeRespuestaDTO('', '', '');
    this._spinner.hide();
  }

  /**
   *
   */
  ngOnInit() {
    this.getPublicIp();
    this._configurationService.inhabilitarBotonAtras();
    this.getListaDocumentos();


    this._spinner.show();
    this.profileForm = this._formB.group({
      tipoDocumento: ['', [Validators.required]],
      numDocumento: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/)]]
    });
    this._spinner.hide();
  }

  public getListaDocumentos() {
    this._recuperarInfoServices.validarListaDocumentos().then(
      res => {
        this.listaTipoDocumentos = res;
      }
    )
  }

  /**
   * Se encarga de consultar el idioma del navegador
   */
  private getNavigatorLang() {
    this.defaultLanguage = this._translateService.getBrowserLang();
    //if (this.defaultLanguage != 'es' && this.defaultLanguage != 'en') {
    this.defaultLanguage = 'es';
    //}
  }

  /*Metodo encargado de consultar la ip del cliente para almacenarla
    en el objeto respuesta*/
  public getPublicIp() {
    let self = this;
    this._loginService.getIp().then(res => {
      self._configurationControlService.publicIp = res['ip'];
    })
  }

  /** Método encargado de ejecutar el captcha y solicitar el score */
  public recaptcha(): void {
    let self = this;
    this._recaptchaService.execute('login', this._configurationControlService.publicIp).then(result => {
      let whiteListDTO = new WhiteListDTO(self._configurationControlService.publicIp, result);

      self._loginService.verifyWhiteList(whiteListDTO).then(res => {
        if (res == "true") {
          this.validarUsuario();
        } else {
          this.errorRecaptcha();
        }
      })
    });

  }

  /**
   * Método que se encarga de llamar el servicio para la recuperación de contraseña.
   */
  public validarUsuario(/*captchaResponse: string*/): void {

    /*if (captchaResponse == null) {
        return;
    }*/

    this._spinner.show();
    if (this.tipoComponente == '1') {
      var tDoc = this.profileForm.get('tipoDocumento').value;
      var infoT = this.profileForm.get('numDocumento').value;

      var docCompleto = tDoc + infoT;
      this._recuperarInfoServices.validarUsuario(docCompleto, 'REUSU', "").then(
        res => {
          this.mensajeSalida = res;
          this._spinner.hide();
          $('#verRespuesta').modal({ show: 'true' });
        }, err => {
          this.mensajeSalida = err.error;
          this._spinner.hide();
          $('#verRespuesta').modal({ show: 'true' });
        }
      );
    }

    if (this.tipoComponente == '2') {
      if (this.selOpt == 'SNP') {
        var docCompleto = this.profileForm.get('usuario').value;
      }
      if (this.selOpt == 'DI') {
        var tDoc = this.profileForm.get('tipoDocumento').value;
        var infoT = this.profileForm.get('numDocumento').value;
        var docCompleto = tDoc + infoT;
      }

      this._recuperarInfoServices.validarUsuario(docCompleto, 'RECON', this.selOpt).then(
        res => {
          this.mensajeSalida = res;
          this._spinner.hide();
          $('#verRespuesta').modal({ show: 'true' });
        }, err => {
          this.mensajeSalida = err.error;
          this._spinner.hide();
          $('#verRespuesta').modal({ show: 'true' });
        }
      );
    }
    // this._captchaService.reloadCaptcha();
  }

  /**
   * Método que sirve para eliminar los datos de documentos y usuario ingresados.
   */
  public borrarDatos(valorI: string): void {
    this._spinner.show();
    this.selOpt = valorI;

    if (this.selOpt == "SNP") {
      this.profileForm = this._formB.group({
        usuario: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/)]]
      });
    } else {
      this.profileForm = this._formB.group({
        tipoDocumento: ['', [Validators.required]],
        numDocumento: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/)]]
      });
    }
    this._spinner.hide();
  }

  /** Método encargado de manejar el error en el recaptcha */
  public errorRecaptcha() {
    this._translateService.get('mensaje.usuario.no.humano')
      .subscribe((res: string) => {
        this.mensajeSalida = new MensajeRespuestaDTO(res, '', '');
        this._spinner.hide();
        $('#verRespuesta').modal({ show: 'true' });
      });
  }
}
